/**
 * EmptyState — "nothing found" message
 */

import { createElement } from '../utils/dom.js';

export default class EmptyState {
  /**
   * @param {Object} i18n - I18n instance
   */
  constructor(i18n) {
    this._i18n = i18n;
    this._el = null;
  }

  /**
   * Render the empty state
   * @param {HTMLElement} container
   */
  render(container) {
    this._el = createElement('div', 'grb-widget--empty');

    this._el.appendChild(
      createElement('div', 'grb-widget--empty-title', {}, [this._i18n.t('results.notFound')])
    );
    this._el.appendChild(
      createElement('div', 'grb-widget--empty-hint', {}, [this._i18n.t('results.notFoundHint')])
    );

    container.appendChild(this._el);
  }

  show() {
    if (this._el) this._el.style.display = '';
  }

  hide() {
    if (this._el) this._el.style.display = 'none';
  }

  destroy() {
    if (this._el && this._el.parentNode) {
      this._el.parentNode.removeChild(this._el);
    }
    this._el = null;
  }
}
